import { render, staticRenderFns } from "./FormPaymentReceiptAccount.vue?vue&type=template&id=0fd2173d"
import script from "./FormPaymentReceiptAccount.vue?vue&type=script&lang=js"
export * from "./FormPaymentReceiptAccount.vue?vue&type=script&lang=js"
import style0 from "./FormPaymentReceiptAccount.vue?vue&type=style&index=0&id=0fd2173d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports